export default __webpack_public_path__ + "static/media/jan_coles.2d3a034f.jpg";